import { render, staticRenderFns } from "./ValidationDetails.vue?vue&type=template&id=0f597b7b&scoped=true&"
import script from "./ValidationDetails.vue?vue&type=script&lang=js&"
export * from "./ValidationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f597b7b",
  null
  
)

export default component.exports